import { Logo } from "@/components/Logo";

export const AuthLayout = ({ title, subtitle, children, side }) => (
  <div className="grid min-h-screen lg:grid-cols-2">
    <div className="grain relative hidden overflow-hidden bg-[#0B192C] lg:block">
      <img src="/img/comfort-taxi.jpg" alt="Comfort Taxi" className="absolute inset-0 h-full w-full object-cover opacity-50" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B192C] via-[#0B192C]/80 to-blue-900/40" />
      <div className="relative flex h-full flex-col justify-between p-12">
        <Logo dark />
        <div className="max-w-md">
          <h2 className="text-4xl font-extrabold leading-tight tracking-tight text-white">{side?.title}</h2>
          <p className="mt-4 text-blue-100/80">{side?.text}</p>
        </div>
      </div>
    </div>
    <div className="flex flex-col bg-white px-6 py-8 sm:px-12">
      <div className="lg:hidden"><Logo /></div>
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-10">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">{subtitle}</p>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-xs font-bold uppercase tracking-widest text-slate-500">{label}</span>
    {children}
  </label>
);

export const inputCls = "h-12 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 text-sm text-slate-900 outline-none transition-colors focus:border-blue-600 focus:bg-white focus:ring-4 focus:ring-blue-600/10";

export const primaryBtn = "flex h-12 w-full items-center justify-center rounded-xl bg-blue-700 font-semibold text-white shadow-lg shadow-blue-700/25 transition-all hover:bg-blue-600 active:scale-[0.98] disabled:opacity-60";
